/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCount24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='#484C51'
        d='M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z'
      />
      <path
        fill='#fff'
        d='M8.288 16h1.476V7.66H8.552c-.276.888-.912 1.332-1.8 1.344H6.5v1.332h.384c.516 0 1.116-.168 1.404-.504V16zm3.182 0h5.856v-1.236h-3.852a14.196 14.196 0 002.064-1.536c1.164-1.056 1.704-2.04 1.704-3.192 0-1.632-1.044-2.556-2.808-2.556-1.8 0-2.916.972-2.916 2.496 0 .204.024.432.084.66l1.488.144a3.424 3.424 0 01-.084-.732c0-.828.504-1.356 1.356-1.356.84 0 1.308.504 1.308 1.416 0 .912-.336 1.584-1.284 2.472a21.765 21.765 0 01-2.916 2.292V16z'
      />
    </svg>
  );
}

export default SvgCount24;
